import { Injectable, Injector, inject } from '@angular/core';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';

import { ResultDialogComponent } from '../ui';
import { LoyaltyProgramResult } from '../types';

@Injectable({
  providedIn: 'root',
})
export class ResultDialogService {
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);

  open(type: LoyaltyProgramResult) {
    return this.dialogService.open(new PolymorpheusComponent(ResultDialogComponent, this.injector), {
      data: type,
    });
  }
}
